export const AITARGETING = `<p>AI Targeting is a revolutionary solution for predicting future investor 
behaviors and tendencies. <a href="https://vimeo.com/272363292" target="_blank">Watch Video</a></p>
<p>AI Target Scores are created each day for over 5K institutional investors and 40K mutual funds. This is a first 
of its kind model that, through a deep analysis of historical correlation and regression, generates probabilities 
and matches these scores between institutional investment firms / funds, and publicly traded companies.</p>`

export const MAX_PURCHASING_POWER_LENGTH = 12
